/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Heading_LabelInputs */

const en_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered By`)
};

const ar_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شُغِّل بواسطة`)
};

const bn_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাওয়ার্ড বাই`)
};

const de_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützt von`)
};

const es_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollado con`)
};

const fr_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propulsé par`)
};

const pt_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvido com`)
};

const zh_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术支持`)
};

const tr_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destekleyen`)
};

const ru_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При поддержке`)
};

const pl_pb_heading_label = /** @type {(inputs: Pb_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługiwane przez`)
};

/**
* | output |
* | --- |
* | "Powered By" |
*
* @param {Pb_Heading_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const pb_heading_label = /** @type {((inputs?: Pb_Heading_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Heading_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_pb_heading_label(inputs)
	if (locale === "bn") return bn_pb_heading_label(inputs)
	if (locale === "de") return de_pb_heading_label(inputs)
	if (locale === "es") return es_pb_heading_label(inputs)
	if (locale === "fr") return fr_pb_heading_label(inputs)
	if (locale === "pt") return pt_pb_heading_label(inputs)
	if (locale === "zh") return zh_pb_heading_label(inputs)
	if (locale === "tr") return tr_pb_heading_label(inputs)
	if (locale === "ru") return ru_pb_heading_label(inputs)
	if (locale === "pl") return pl_pb_heading_label(inputs)
	return en_pb_heading_label(inputs)
});